import { AnyAction } from 'redux';
import { isNull, get, find, isNil } from 'lodash';
import { callApiNext } from 'helpers/saga-helpers';
import { put, select, takeLeading } from 'redux-saga/effects';
import {
  REQUEST_GET_MISSION_BY_ID,
  REQUEST_READ_MISSION,
} from 'containers/ExpertAssignedMissionShow/constants';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';

import {
  requestReadMission,
  setExpertiseMissionAction,
} from 'containers/ExpertAssignedMissionShow/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import {
  requestGetMissionPostPone,
  requestGetMissionPostPoneExpertise,
} from 'containers/ExpertExpertise/actions';
import { MISSION_POSTPONE_TYPE } from 'containers/data-structure';

export function* getMissionById(action: AnyAction): Generator<unknown> {
  const { payload } = action;
  const token = yield select(makeSelectKeycloakToken());
  const currentExpertCode = currentIntervenantStorage.get()?.sagis_code;
  const path = `/corporeal/mission/${payload}`;
  if (!token) return null;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  };
  let response: any;
  response = yield callApiNext(
    path,
    {},
    options,
    [],
    setExpertiseMissionAction,
  );

  if (!isNil(get(response.data[0], 'claimId', null))) {
    yield put(requestClaimRecap(get(response.data[0], 'claimId', null)));
  }
  const assignedExpertRead = find(
    response.data[0]?.assignedExperts,
    (item: any) => item.expertCode.toString() === currentExpertCode.toString(),
  );
  yield put(
    requestGetMissionPostPone({
      missionId: payload,
      type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
      claimId: null,
      isIntervenant: true,
    }),
  );
  yield put(
    requestGetMissionPostPoneExpertise({
      missionId: payload,
      type: MISSION_POSTPONE_TYPE.POSTPONEMENTS_EXPERTISE,
      claimId: null,
      isIntervenant: true,
    }),
  );

  if (!get(assignedExpertRead, 'isReadMission')) {
    yield put(
      requestReadMission({
        claimId: response.data[0]?.claimId,
        id: assignedExpertRead.id,
        missionId: assignedExpertRead.missionId,
      }),
    );
  }
}

export function* getMissionByIdSaga() {
  yield takeLeading(REQUEST_GET_MISSION_BY_ID, getMissionById);
}

export function* requestReadMissionS(action: AnyAction): Generator<unknown> {
  const { payload } = action;
  const token = yield select(makeSelectKeycloakToken());
  const path = `/corporeal/mission/read-mission`;
  if (isNull(token)) return;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  yield callApiNext(path, {}, options, []);
}
export function* requestReadMissionSaga() {
  yield takeLeading(REQUEST_READ_MISSION, requestReadMissionS);
}
export default [getMissionByIdSaga, requestReadMissionSaga];
